import BaseModel from "./BaseModel";
import CourseModuleVideoResourse from "./CourseModuleVideoResourse";
import Lesson from "./Lesson";
import CourseModuleVideoDictionary from "@/dictionary/CourseModuleVideoDictionary";

/**
 * CourseModuleVideo 
 */
export default class CourseModuleVideo extends BaseModel{

  constructor({
    id,
    course_module,
    video_path,
    description,
    courseModuleVideoOrder,
    timeInMinutes,
    active,
    created_at,
    updated_at,
    deleted_at,
    resourses,
    lesson,
    watched
  }) {
    super();
    
    this.dictionary = new CourseModuleVideoDictionary();

    this.id = id || null;
    this.course_module = course_module || null;
    this.video_path = video_path || null;
    this.description = description || null;
    this.courseModuleVideoOrder = courseModuleVideoOrder || null;
    this.timeInMinutes = timeInMinutes || null;
    this.active = [true, 1, '1'].includes(active)  ? true : false;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.deleted_at = deleted_at || null;
    this.resourses = resourses || null;
    this.lesson = lesson || null;
    this.watched = watched != undefined && watched == this.dictionary.WATCHED || this.dictionary.NOT_WATCHED;

    if (this.resourses)
      this.handleResourses();

    if (this.lesson)
      this.handleLesson();
  }

  /**
   * Parses this.resourses to CourseModuleVideoResourse objects array
   */
  handleResourses() {
    if (Array.isArray(this.resourses)) {

      let resoursesArr = [];
      for (let resourse of this.resourses) {
        resoursesArr.push(new CourseModuleVideoResourse(resourse));
      }

      this.resourses = resoursesArr;
    }
  }

  /**
   * Parses this.lesson to Lesson object
   */
  handleLesson() {
    this.lesson = new Lesson(this.lesson);
  }

  /**
   * Checks if this Video has Resourses
   * @returns {boolean}
   */
  hasResourses() {
    return this.resourses != null && this.resourses.length > 0 ? true : false;
  }

  /**
   * Checks if this Video has a Lesson
   * @returns {boolean}
   */
  hasLesson() {
    return this.lesson != null ? true : false;
  }

  /**
   * Sets this video status as watched
   */
  setAsWatched() {
    return this.watched = this.dictionary.WATCHED;
  }

  /**
   * Sets this video status as watched
   */
  setAsNotWatched() {
    return this.watched = this.dictionary.NOT_WATCHED;
  }

  /**
   * Checks if video was alread watched
   */
  alreadWatched() {
    return this.watched == this.dictionary.WATCHED;
  }
}